/**
 * AV API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConstraintData } from './constraintData';


export interface FieldMetaData { 
    identifier?: string;
    access?: FieldMetaData.AccessEnum;
    constraintData?: Array<ConstraintData>;
}
export namespace FieldMetaData {
    export type AccessEnum = 'ALLOWED' | 'NONE' | 'DEACTIVATED';
    export const AccessEnum = {
        ALLOWED: 'ALLOWED' as AccessEnum,
        NONE: 'NONE' as AccessEnum,
        DEACTIVATED: 'DEACTIVATED' as AccessEnum
    };
}


